export const ABOUT_PAGE_CONTENT = [
  {
    id: 'content1',
    title: 'Exciting',
    content:
      'We feel that life should be fun, enthusiastic, and full of adventure. We live to create those special moments in life and to make sure people can share them with each other in the best possible way. We live for the thrill.',
  },
  {
    id: 'content2',
    title: 'Empowering',
    content:
      'We put the power into people’s hands. By communicating with a clear and straightforward voice, we give people on both sides a platform and everything they need to make well-informed decisions.',
  },
  {
    id: 'content3',
    title: 'Vibrant',
    content:
      "We aspire to help people live life to the fullest. Giving energy, encouraging, and embracing people's needs and passions in a meaningful and lively way is what we do best.",
  },
  {
    id: 'content4',
    title: 'Genuine',
    content:
      "We strive to make everything we offer more trustworthy to everyone involved. Safety is at the centre of who we are. We make sure that all sides of the connections we create can feel that they're in good hands, and that the only surprises they find are the delightful ones.    ",
  },
  {
    id: 'content5',
    title: 'Inspirational',
    content:
      'We believe that storytelling is powerful. It allows people to express themselves and inspire others to do the same. Through personal stories, people are able to relate and feel more connected with the world and each other.    ',
  },
];

export const ABOUT_PAGE_CONTENT_FINLAND = [
  {
    id: 'content1',
    title: 'Hubista on jännittävä markkinapaikka',
    content: `Mielestämme elämän tulee olla hauskaa, monimuotoista ja täynnä seikkailuja. Pyrimme tukemaan eri 
        ihmisten erityisiä hetkiä elämässä ja varmistamaan, että kaikki voivat jakaa nämä hetket toistensa kanssa 
        parhaalla mahdollisella tavalla. Onnistunut elämys on elämän suola.`,
  },
  {
    id: 'content2',
    title: 'Hubista mahdollistaa toteutukset',
    content: `Annamme ihmisille mahdollisuuden ottaa ohjat omiin käsiin. Kommunikoimalla selkeällä ja 
        suoraviivaisella äänellä annamme molemmille osapuolille alustan ja kaiken, mitä he tarvitsevat 
        helpottamaan pienien ja suurien päätösten tekemistä.`,
  },
  {
    id: 'content3',
    title: 'Hubista on kannustava',
    content: `Haluamme tukea ihmisiä elämään täysillä. Tavoitteenamme on antaa energiaa, kannustaa ja 
        tukea ihmisten tarpeita ja mielenkiinnon kohteita mielekkäällä ja helpolla tavalla.`,
  },
  {
    id: 'content4',
    title: 'Hubista on aito',
    content: `Pyrimme tekemään kaikista tarjoamistamme palveluista luotettavia kaikille osapuolille. 
        Turvallisuus on tekemisemme keskipisteessä. Varmistamme, että luomiemme yhteyksien kaikki osapuolet 
        tuntevat olevansa hyvissä käsissä ja että ainoat yllätykset, joita käyttäjämme kokevat, olisivat positiivisia.`,
  },
  {
    id: 'content5',
    title: 'Hubista on inspiroiva',
    content: `Uskomme tarinankerronnan voimaan. Sen avulla ihmiset voivat ilmaista itseään ja innostaa muita 
        tekemään samoin. Haluamme tukea yksilöitä ja uskomme, että kiinnostus, mielenkiinto ja intohimo 
        tarttuvat ihmiseltä ihmiselle. Tavoitteenamme on mahdollistaa uusien kiinnostusten löytämisen ja 
        auttamaan ihmisiä pääsemään lähemmäs omia kiinnostuksen kohteitaan.`,
  },
];

export const ABOUT_PAGE_CONTENT_SWEDEN = [
  {
    id: 'content1',
    title: 'Välkommen till något spännande',
    content: `Vi tror på ett liv fyllt av entusiasm! Vi vill hjälpa dig att skapa dessa härliga stunder av glädje och gärna på ett sätt så att du kan dela dem med andra.`,
  },
  {
    id: 'content2',
    title: 'Vi gör det möjligt',
    content: `Vi vill skapa bästa möjliga utbudet för just dig! Hubista bygger på transparens och öppenhet där både köpare och säljare ska kunna känna att de kan fatta välgrundade beslut.`,
  },
  {
    id: 'content3',
    title: 'Mot nya höjder',
    content: `Vi vill göra det möjligt för fler att kunna nå nya nivåer. Att omfamna dina behov och passioner på ett livfullt sätt är det vi är bäst på.`,
  },
  {
    id: 'content4',
    title: 'Med ett stort hjärta',
    content: `Vi strävar efter att skapa ett förtroendeingivande innehåll för alla användare. Personer på båda sidor av tjänsten ska känna att de är i goda händer och att de enda överraskningar som kan komma är roliga sådana.`,
  },
  {
    id: 'content5',
    title: 'Det finns så mycket att upptäcka',
    content: `Vi tror att varje människa har en spännande historia att förmedla. Den här historien kan vi ge liv till och genom Hubista kan den också inspirera andra. Personliga historier gör att folk kan relatera till varandra och se meningar och nya samband i tillvaron.`,
  },
];
